// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React, {useEffect, useRef} from 'react';

import {useOverlayScrollbars} from 'overlayscrollbars-react';

import {getDefaultOptions} from '../utils/get-default-options';

import type {Options} from '../utils/get-default-options';
import type {OverlayScrollbars} from 'overlayscrollbars';

export const useScrollWithExternalScrollbars = (option?: Options): {
    ref: React.RefObject<HTMLDivElement | null>,
    scrollbarsSlotRef: React.RefObject<HTMLDivElement | null>,
    instance: () => OverlayScrollbars | null,
} => {
    const ref = useRef<HTMLDivElement>(null);
    const scrollbarsSlotRef = useRef<HTMLDivElement>(null);
    const [initialize, instance] = useOverlayScrollbars({
        options: getDefaultOptions(option),
    });
    useEffect(() => {
        if (!ref.current || !scrollbarsSlotRef.current) {
            return;
        }
        initialize({
            target: ref.current,
            scrollbars: {
                slot: scrollbarsSlotRef.current,
            },
        });
        return () => {
            instance()?.destroy();
        };
    }, [instance, initialize]);

    return {
        ref,
        scrollbarsSlotRef,
        instance,
    };
};
